import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IInformationSettingResponse,
} from "models/setting/general";
import { httpStatus } from "configs/httpStatus";
import { getInformationSetting } from "services/setting";
import {
  handleSuccessAction,
  handleErrorAction,
} from "./generalSettingActions";

function* getSettingInformationSaga() {
  const statusCodeArr = [httpStatus.StatusOK, httpStatus.StatusNotFound];
  try {
    const response: IInformationSettingResponse = yield call(
      getInformationSetting
    );
    if (statusCodeArr.includes(response.status)) {
      yield put(handleSuccessAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onSettingInformationWatcher() {
  yield takeLatest(
    ActionType.INFORMATION_SETTING as any,
    getSettingInformationSaga
  );
}

export default [fork(onSettingInformationWatcher)];
